import script from "./OffertaPMI.vue?vue&type=script&setup=true&lang=js"
export * from "./OffertaPMI.vue?vue&type=script&setup=true&lang=js"

import "./OffertaPMI.vue?vue&type=style&index=0&id=df80f32c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df80f32c"]])

export default __exports__